(function () {
  var COOKIE_NAME = "audience_gate_confirmed";
  var COOKIE_DAYS = 180;
  var DECLINE_REDIRECT_URL = "https://www.google.com/";

  function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  }

  function setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + encodeURIComponent(value) + "; " + expires + "; path=/; SameSite=Lax";
  }

  function openModal(dialog) {
    if (!dialog) return;

    // Some browsers might not support <dialog>. Fallback to adding [open].
    if (typeof dialog.showModal === "function") {
      try {
        dialog.showModal();
      } catch (e) {
        dialog.setAttribute("open", "open");
      }
    } else {
      dialog.setAttribute("open", "open");
    }

    document.documentElement.classList.add("audience-gate-modal-open");
  }

  function closeModal(dialog) {
    if (!dialog) return;

    if (typeof dialog.close === "function") {
      try {
        dialog.close();
      } catch (e) {
        dialog.removeAttribute("open");
      }
    } else {
      dialog.removeAttribute("open");
    }

    document.documentElement.classList.remove("audience-gate-modal-open");
  }

  function init() {
    var dialog = document.getElementById("AudienceGateModal");
    if (!dialog) return;

    // Only show once per visitor (cookie).
    var confirmed = getCookie(COOKIE_NAME);
    if (confirmed === "true") return;

    // Prevent closing by clicking outside (optional but recommended for gating).
    dialog.addEventListener("cancel", function (event) {
      event.preventDefault();
    });

    // Clicking backdrop should not close it.
    dialog.addEventListener("click", function (event) {
      var rect = dialog.getBoundingClientRect();
      var clickedInDialog =
        rect.top <= event.clientY &&
        event.clientY <= rect.top + rect.height &&
        rect.left <= event.clientX &&
        event.clientX <= rect.left + rect.width;

      if (!clickedInDialog) {
        event.preventDefault();
      }
    });

    var proceedBtn = dialog.querySelector("[data-audience-gate-proceed]");
    var declineBtn = dialog.querySelector("[data-audience-gate-decline]");
    var closeBtn = dialog.querySelector("[data-audience-gate-close]");

    if (proceedBtn) {
      proceedBtn.addEventListener("click", function () {
        setCookie(COOKIE_NAME, "true", COOKIE_DAYS);
        closeModal(dialog);
      });
    }

    if (declineBtn) {
      declineBtn.addEventListener("click", function () {
        // No cookie set. Redirect immediately.
        window.location.href = DECLINE_REDIRECT_URL;
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener("click", function () {
        closeModal(dialog);
      });
    }

    // Show after DOM is ready.
    openModal(dialog);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();